import React from 'react';
import { GrTechnology } from 'react-icons/gr';
import LogoStyles from '../styles/LogoStyles';

function Logo() {
  return (
    <LogoStyles to="/">
      <GrTechnology />
    </LogoStyles>
  );
}

export default Logo;
